"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putStaticFields = void 0;
function putStaticFields(Component, staticData) {
    Object.entries(staticData)
        .filter(function (_a) {
        var key = _a[0];
        return key !== 'default';
    })
        .forEach(function (_a) {
        var key = _a[0], value = _a[1];
        Component[key] = value;
    });
    return Component;
}
exports.putStaticFields = putStaticFields;
